import Script from "next/script"

export const ParentWelcomeVideo = () => {
  return(
    <>
      <div style={{ padding: "56.25% 0 0 0", position: "relative", width: '100%' }}>
        <iframe
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          src="https://player.vimeo.com/video/1195492420?badge=0&autopause=0&player_id=0&app_id=58479"
          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
          title="HEALTH4LIFE WELCOME_V1T3"
        />
      </div>
      <Script src="https://player.vimeo.com/api/player.js" />
    </>
  )
};